import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';

import { createDroneTrackingOptions, DRONE_TRACKING_OPTIONS } from './config/drone-tracking-options';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    {
      provide: DRONE_TRACKING_OPTIONS,
      useFactory: createDroneTrackingOptions,
    },
  ]
};
